import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const SEO_BY_PATH = {
  '/': {
    title: 'Backup Meraki - Automated Cisco Meraki Configuration Backup Solution',
    description:
      'BackupMeraki provides a secure, automated way to back up your Cisco Meraki network configurations. Easily schedule backups, restore settings, and protect your infrastructure with powerful cloud-based automation tools designed for network reliability.',
  },
  '/pricing': {
    title: 'BackupMeraki Pricing | Simple Plans for Every Network',
    description:
      'Choose a flexible BackupMeraki plan that suits your network size and backup needs. Enjoy transparent pricing, unlimited configuration history, automated scheduling, and quick restores — all designed to safeguard your Cisco Meraki environment.',
  },
  '/about-us': {
    title: 'About BackupMeraki',
    description:
      'At Backup Meraki, we’re passionate about simplifying Cisco Meraki configuration management through automation. Our platform helps organizations enhance security, minimize downtime, and ensure complete control of their network settings.',
  },
  '/terms-of-service': {
    title: 'Terms of Service | BackupMeraki',
    description:
      'Review BackupMeraki’s Terms of Service for information about account usage, data handling, user rights, and service limitations. We’re committed to transparency and to delivering a secure, compliant network backup experience.',
  },
  '/privacy-policy': {
    title: 'Privacy Policy | BackupMeraki',
    description:
      'Learn how BackupMeraki collects, uses, and protects your information. We value privacy and follow strict data protection standards to ensure your Cisco Meraki configurations and account details remain fully secure.',
  },
  '/release-notes': {
    title: 'Release Notes | BackupMeraki',
    description:
      'Explore BackupMeraki’s latest product releases, feature enhancements, and performance updates. Our commitment to continuous improvement ensures your Cisco Meraki backups remain efficient, secure, and easy to manage.',
  },
  '/how-it-works': {
    title: 'How to Back Up Cisco Meraki | BackupMeraki',
    description:
      'Discover how BackupMeraki automates Cisco Meraki configuration backups. With a simple setup, secure API integration, and cloud-based storage, you can easily save, schedule, and restore configurations with confidence.',
  },
  '/faq': {
    title: 'FAQ | BackupMeraki',
    description:
      'Find answers to common questions about BackupMeraki, from setup and Cisco Meraki API access to automated backup schedules, storage, and configuration restore options for your network.',
  },
  '/security': {
    title: 'Security | BackupMeraki',
    description:
      'Learn how BackupMeraki protects your Cisco Meraki configurations with encryption at rest and in transit, multi-factor authentication, user-defined data regions, dedicated backup infrastructure, and a fully managed, continuously assessed cloud environment.',
  },
  '/404': {
    title: '404 | BackupMeraki',
    description: 'The page you are looking for could not be found.',
    noindex: true,
  },
}

function upsertMeta(name, content) {
  let meta = document.head.querySelector(`meta[name="${name}"]`)

  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('name', name)
    document.head.appendChild(meta)
  }

  meta.setAttribute('content', content)
}

export default function SeoMeta() {
  const { pathname } = useLocation()
  const normalizedPath = pathname !== '/' ? pathname.replace(/\/+$/, '') : pathname

  useEffect(() => {
    const seo = SEO_BY_PATH[normalizedPath] || SEO_BY_PATH['/404']

    document.title = seo.title
    upsertMeta('description', seo.description)

    if (seo.noindex) {
      upsertMeta('robots', 'noindex, nofollow')
      return
    }

    const robotsMeta = document.head.querySelector('meta[name="robots"]')

    if (robotsMeta) {
      robotsMeta.remove()
    }
  }, [normalizedPath])

  return null
}
